import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { BASE_URL } from '@teamfoster/sdk/ssr';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeNl, 'nl');
bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(),...appConfig.providers, { provide: BASE_URL, useFactory: getBaseUrl }] });
